<template>
  <v-container fluid style="height:100%" pa-0 ma-0>
    <v-toolbar style="padding:0px"   flat color="white" height="50">
      <v-toolbar-title  >Katetaulu</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="isMarginTableOpen = !isMarginTableOpen" color="#CCC" height="30" class="avecor-button-global avecor-button-group-button mr-4">
          {{isMarginTableOpen ? 'Pienennä katetaulu' : 'Näytä katetaulu'}}
        </v-btn>
      <v-btn-toggle  :multiple="false" :mandatory="settings.toggleMandatory" style="border:1px #ccc solid; margin-right:20px;" v-model="selectedYear">
        <v-btn :value="thisYear" height="30" class="avecor-button-global avecor-button-group-button">
          {{thisYear}}
        </v-btn>
        <v-btn :value="lastYear" height="30" class="avecor-button-global avecor-button-group-button">
          {{lastYear}}
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    <v-row no-gutters fill-height v-if="isMarginTableOpen">
      <v-col col="12">
        <MarginsMarginTable v-if="staff[user.uid].isAdmin || staff[user.uid].role == 'office' || (staff[user.uid].role == 'sales' && this.staff[this.user.uid].marginsAccess)" dataRestriction="none" chartType="table" metric="bothMargins" label="Katteet" dateSplit="months" salesperson="salespersons" :year="selectedYear" />
        <MarginsMarginTable v-if="!staff[user.uid].isAdmin && staff[user.uid].role == 'sales' && !this.staff[this.user.uid].marginsAccess" :dataRestriction="staff[user.uid].id" chartType="table" metric="bothMargins" label="Katteet" dateSplit="months" salesperson="salespersons" :year="selectedYear"/>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-2" style="border-top:5px solid #ccc" >
      <MarginsOrdersTable></MarginsOrdersTable>
    </v-row>  
  </v-container>  
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import MarginsOrdersTable from './../../components/blocks/MarginsOrdersTable'
import MarginsMarginTable from './../../components/blocks/MarginsMarginTable'


export default {
    components: {
      MarginsOrdersTable,
      MarginsMarginTable
    },
    data () {
      return {
        clipped: true,
        right: true,
        miniVariant: true,
        isMarginTableOpen:true,
        thisYear:new Date().getFullYear(),
        lastYear:new Date().getFullYear()-1,
        selectedYear:new Date().getFullYear(),
      }
    },
    mounted() {
    },
    computed: {
      formTitle () {
      },
      ...mapFields([
        'staff.staff',
        'settings',
        'user',
      ]),
    },
    created () {},
    methods: {
      
      example(message) {
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Margins.vue